import { message } from 'antd';
import { AxiosError } from 'axios';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import Api from '@/services/api';
import type { BaseContext } from '@/types';
import { ROSA_QUERY_KEYS } from './query-keys';

type UpdateDurationRequest = BaseContext & {
	report_id: string;
	sub_category_id: string;
	duration: number;
};

type UpdateDurationResponse = {
	created_evaluation_duration: {
		id: string;
		report_id: string;
		sub_category_id: string;
		duration: number;
		updated_at: Date;
		created_at: Date;
	};
	step: number;
};

type UpdateDurationError = AxiosError<any>;

async function updateDuration(parameters: UpdateDurationRequest): Promise<UpdateDurationResponse> {
	const url = `/ergonomic-tool/rosa/evaluation/duration`;
	const { data } = await Api.put<UpdateDurationResponse>(url, parameters);
	return data;
}

export const useUpdateDuration = ({ report_id, sub_category_id, organization_id, company_id }: any) => {
	const queryClient = useQueryClient();
	return useMutation<UpdateDurationResponse, UpdateDurationError, { duration: number }>(
		({ duration }) => {
			const payload = {
				organization_id,
				company_id,
				report_id,
				sub_category_id,
				duration
			};

			return updateDuration(payload);
		},
		{
			onError: () => {
				message.error(I18n.get('Error save duration!'));
			},
			onSuccess: () => {
				queryClient.invalidateQueries([ROSA_QUERY_KEYS.GET_SCORES]);
			}
		}
	);
};
